import { __decorate } from "tslib";
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import raf from 'raf';
import { pxToRem } from '../../../es/_util/UnitConvertor';
import measureScrollbar from '../../../es/_util/measureScrollbar';
import autobind from '../_util/autobind';
import TableContext from './TableContext';
import { ColumnLock, TableAutoHeightType } from './enum';
let TableBody = class TableBody extends Component {
    saveRef(node) {
        const { getRef } = this.props;
        if (getRef) {
            getRef(node);
        }
        this.element = node;
    }
    componentDidUpdate() {
        const { element } = this;
        if (element) {
            const { scrollHeight, clientHeight } = element;
            // Fixed vertical scrollbar not displayed in Chrome when scrollHeight - clientHeight < scrollbarHeight
            if (scrollHeight > clientHeight && scrollHeight - clientHeight < measureScrollbar()) {
                const { overflow } = element.style;
                element.style.overflow = 'scroll';
                raf(() => {
                    element.style.overflow = overflow;
                });
            }
        }
    }
    getHeightStyle() {
        const { tableStore: { height, autoHeight, customized: { heightType }, }, } = this.context;
        if (!heightType && autoHeight && autoHeight.type === TableAutoHeightType.maxHeight) {
            return undefined;
        }
        return height;
    }
    render() {
        const { children, lock, onScroll } = this.props;
        const { tableStore: { prefixCls, leftLeafColumnsWidth, rightLeafColumnsWidth, hasFooter, overflowY, overflowX, }, } = this.context;
        const fixedLeft = lock === true || lock === ColumnLock.left;
        const scrollbar = measureScrollbar();
        const hasFooterAndNotLock = !lock && hasFooter && overflowX && scrollbar;
        const height = this.getHeightStyle();
        const tableBody = (React.createElement("div", { ref: this.saveRef, className: `${prefixCls}-body`, style: {
                height: pxToRem(hasFooterAndNotLock && height !== undefined ? height + scrollbar : height),
                marginBottom: hasFooterAndNotLock ? pxToRem(-scrollbar) : undefined,
                width: fixedLeft ? pxToRem(leftLeafColumnsWidth + (scrollbar || 20)) :
                    lock === ColumnLock.right
                        ? pxToRem(rightLeafColumnsWidth - 1 + (overflowY ? scrollbar : 0))
                        : undefined,
                marginLeft: lock === ColumnLock.right ? pxToRem(1) : undefined,
            }, onScroll: onScroll }, children));
        if (fixedLeft) {
            return (React.createElement("div", { style: { width: pxToRem(leftLeafColumnsWidth), overflow: 'hidden' } }, tableBody));
        }
        return tableBody;
    }
};
TableBody.displayName = 'TableBody';
TableBody.contextType = TableContext;
__decorate([
    autobind
], TableBody.prototype, "saveRef", null);
TableBody = __decorate([
    observer
], TableBody);
export default TableBody;
